import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';
import loginReducer from '../features/auth/login';
import parentInfoReducer from '../features/parentInfo/parentInfoSlice';
import reenrolmentReducer from '../features/reenrolment/reenrolmentSlice';
import paymentReducer from '../features/payment/paymentSlice';

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'parentInfo', 'reenrolment', 'payment'], // Persist all form data
};

// Combine reducers
const rootReducer = combineReducers({
  auth: loginReducer,
  parentInfo: parentInfoReducer,
  reenrolment: reenrolmentReducer,
  payment: paymentReducer,
});

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store with persisted reducer
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

// Create persistor
export const persistor = persistStore(store);
